import Entity from "../entity";




export default class SecondHandOrder extends Entity<number> {
 orderNum: string;
  orderState: number;
  productId: number;
  title: string;
  publishName: string;
  phoneNumber: string;
  address: string;
  price: number;
  description: string;
  isSold: boolean;
  lastModificationTime: null;
  lastModifierUserId: null;
  creationTime: Date;
  creatorUserId: null;
}